var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 6.66667C6.73573 6.66667 7.33268 6.06971 7.33268 5.33333C7.33268 4.59695 6.73573 4 5.99935 4C5.26297 4 4.66602 4.59695 4.66602 5.33333C4.66602 6.06971 5.26297 6.66667 5.99935 6.66667Z",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66732 1.33334H6.00065C2.66732 1.33334 1.33398 2.66668 1.33398 6.00001V10C1.33398 13.3333 2.66732 14.6667 6.00065 14.6667H10.0007C13.334 14.6667 14.6673 13.3333 14.6673 10V6.66668",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7593 1.72666L10.3393 4.14665C10.2459 4.23999 10.1526 4.41999 10.1393 4.55332L10.0059 5.47999C9.95928 5.81332 10.1926 6.04665 10.5259 5.99999L11.4526 5.86666C11.5793 5.84666 11.7659 5.75999 11.8593 5.66665L14.2793 3.24666C14.6993 2.82666 14.8926 2.34666 14.2793 1.73332C13.6593 1.10666 13.1793 1.30666 12.7593 1.72666Z",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4141 2.07333C12.6207 2.80667 13.1941 3.38 13.9274 3.58667",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7793 12.6333L5.06596 10.4267C5.59263 10.0733 6.35263 10.1133 6.82596 10.52L7.04596 10.7133C7.56596 11.16 8.40596 11.16 8.92596 10.7133L11.6993 8.33332C12.2193 7.88665 13.0593 7.88665 13.5793 8.33332L14.666 9.26665",
    stroke: "#313131",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.01426239bb56070bb7a6e586de62617f.svg";
export { ForwardRef as ReactComponent };